/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Carry_Why_SetsInputs */

const en_us2_workout_after_carry_why_sets = /** @type {(inputs: Workout_After_Carry_Why_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You changed the number of sets today.`)
};

const pt_br2_workout_after_carry_why_sets = /** @type {(inputs: Workout_After_Carry_Why_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você mudou o número de séries hoje.`)
};

const es_419_workout_after_carry_why_sets = /** @type {(inputs: Workout_After_Carry_Why_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy cambiaste el número de series.`)
};

const pt_pt2_workout_after_carry_why_sets = /** @type {(inputs: Workout_After_Carry_Why_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudaste o número de séries hoje.`)
};

const fr_fr2_workout_after_carry_why_sets = /** @type {(inputs: Workout_After_Carry_Why_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as changé le nombre de séries aujourd'hui.`)
};

const de_de2_workout_after_carry_why_sets = /** @type {(inputs: Workout_After_Carry_Why_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast heute die Anzahl der Sätze geändert.`)
};

const it_it2_workout_after_carry_why_sets = /** @type {(inputs: Workout_After_Carry_Why_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggi hai cambiato il numero di serie.`)
};

/**
* | output |
* | --- |
* | "You changed the number of sets today." |
*
* @param {Workout_After_Carry_Why_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_why_sets = /** @type {((inputs?: Workout_After_Carry_Why_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_Why_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_why_sets(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_why_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_why_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_why_sets(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_why_sets(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_why_sets(inputs)
	return en_us2_workout_after_carry_why_sets(inputs)
});
export { workout_after_carry_why_sets as "workout-after.carry_why_sets" }